import communityReducer from './community';
import { combineReducers } from 'redux';

const rootReducers = combineReducers({
    communityReducer,
});

export default rootReducers;